module.exports = __webpack_public_path__ + "static/newsletter-bg-9150812fbf17b9d7e990630713e65296.webp";